import useResource from "./useResource"

export default function useUnits() {
  return useResource({ key: "/units" })
}
